<template>
  <div class="basic-block block-about-type" :style="styles">
    <img v-if="targetInfo.leadMenu.deco" :src="targetInfo.aboutType.deco" class="block-about-type__deco" alt="">
    <div class="content-wrap">
      <!-- <div class="block-about-type__title">
        <h2 v-html="targetInfo.aboutType.title"></h2>
      </div> -->
      <div class="block-about-type__inner">
        <div class="block-about-type__lead" v-html="targetInfo.aboutType.lead"></div>
        <img :src="resultData.image1" class="block-about-type__img" alt="">
        <!-- <div class="block-about-type__type" v-html="resultData.text3"></div> -->
        <div class="block-about-type__text" v-html="resultData.text8"></div>
      </div>
      <div class="block-about-type__inner">
        <div class="block-about-type__lead" v-html="targetInfo.aboutType.zokusei"></div>
        <img :src="resultData.image2" class="block-about-type__img" alt="">
        <!-- <div class="block-about-type__type" v-html="resultData.text5"></div> -->
        <div class="block-about-type__text" v-html="resultData.text10"></div>
      </div>
      <div class="block-about-type__inner">
        <div class="block-about-type__lead" v-html="targetInfo.aboutType.unkiup"></div>
        <img :src="resultData.image3" class="block-about-type__img" alt="">
        <!-- <div class="block-about-type__type" v-html="resultData.text5"></div> -->
        <div class="block-about-type__text" v-html="resultData.text12"></div>
      </div>
      <div class="link_area">
        <span class="block-about-type__link" @click="onLinkClick">他の誕生日で占う</span>
        <!-- <a href="#" class="block-about-type__link">他の誕生日で占う</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockAboutType',
  components: {
    LpBaseButton,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: Number,
    resultData: Object,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked() {
      location.href = "/user/input"
    },
    onLinkClick() {
      const param = {
        'event_category': `LP${this.lpId}basicresult-free-shindan-button`,
        //'event_label': this.resultData.menu_id
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      const url = `/recommend/lp/${this.lpId}/basic/input`
      location.href = this.$handoverParams(url)
    },
  },
}


</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-about-type {
  background: #EDED67;
  padding: 40px 20px;
  padding-bottom: 60px;
  &__deco {
    position: absolute;
    top: -45px;
    right: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 101;
  }
  &__inner {
    padding: 24px 0;
    background: #fff;
    margin-bottom: 40px;
    padding-top:0;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__title {
    // display: flex;
    // align-items: flex-end;
    // justify-content: center;
    margin: 0 auto 20px;
    // img {
    //   max-width: 70px;
    //   margin: 0 9px 0 0;
    // }
    h2 {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
      color: $l_col_keycolor;
      margin: 0 -10px;
      font-feature-settings: "palt";
    }
  }
  &__lead {
    text-align: center;
    color: #fff;
    margin: 0 0 16px;
    background: #9C8961;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    padding: 6px;
    /deep/ b {
      font-size: 24px;
    }
  }
  &__img {
    max-width: 100%;
    margin: 0 auto 16px;
    vertical-align: middle;
    padding: 0 20px;
  }
  &__text {
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    margin: 0 20px;
  }
  &__type {
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
    text-align: center;
    margin: 0 0 20px;
    color: $l_col_keycolor;
  }
  &__link{
    color: var(--second);
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 12px;
    text-decoration: underline;
  }
  .link_area{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockAboutType.vue